// extracted by mini-css-extract-plugin
export default {"avatar":"OfferTableRow_avatar__zJKgr"};